export default __webpack_public_path__ + "static/media/flam@3x.1a520483.png";